import { ExportTemplate, ExportTemplatesConfig } from "@/types/exportTemplates";
import { DATABASE_EXPORT_PRESETS, FOLDER_BASED_PRESETS } from "./constants";

/**
 * Check if an export template is a database export type
 */
export function isDatabaseExport(template?: ExportTemplate): boolean {
  if (!template) return false;
  return DATABASE_EXPORT_PRESETS.includes(template.id as any);
}

/**
 * Check if an export template is a folder-based type
 */
export function isFolderBasedExport(template?: ExportTemplate): boolean {
  if (!template) return false;
  return FOLDER_BASED_PRESETS.includes(template.id as any);
}

/**
 * Get active template from game settings
 */
export function getActiveTemplate(
  exportConfig?: ExportTemplatesConfig
): ExportTemplate | undefined {
  if (!exportConfig?.activeTemplateId) return undefined;
  return exportConfig.templates?.find(t => t.id === exportConfig.activeTemplateId);
}

/**
 * Generate a clean filename for downloads
 */
export function generateCleanFilename(name: string, suffix: string): string {
  const timestamp = new Date().toISOString().split('T')[0];
  const cleanName = name.replace(/[^a-z0-9]/gi, '_').toLowerCase();
  return `${cleanName}_${suffix}_${timestamp}`;
}

/**
 * Download data as JSON file
 */
export function downloadJSON(data: unknown, filename: string): void {
  const jsonString = JSON.stringify(data, null, 2);
  const blob = new Blob([jsonString], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  
  link.href = url;
  link.download = `${filename}.json`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

/**
 * Download a blob file
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
